module.exports = __webpack_public_path__ + "img/rule2.6006b90a.png";